module.exports = __webpack_public_path__ + "img/gustavo_sandoval.38d9fafa.png";